<template>
  <v-container class="limited">
    <v-layout column>
      <beneficiary-data is-plan-delete></beneficiary-data>
      <v-card class="pa-5" :color="highContrast ? 'dark' : 'white'" column>
        <v-layout column>
          <v-layout justify-space-between align-center row>
            <h4
              class="subheading font-weight-bold font-weight-light primary--text mb-3"
            >
              Exclusão do plano
            </h4>
            <h4 class="subheading font-weight-light mb-3">
              Passo 0{{ step }} de 0{{ totalStep }}
            </h4>
          </v-layout>

          <p>
            {{
              beneficiarioExcluidoEmpresa.message
                ? beneficiarioExcluidoEmpresa.message
                : ""
            }}
          </p>

          <v-layout align-start column v-if="isPrimeiroPasso">
            <v-list two-line>
              <template v-for="(item, index) in familia">
                <v-list-tile :key="item.codigoBeneficiario" ripple>
                  <v-list-tile-action>
                    <v-checkbox
                      v-model="familia[index].selecionado"
                      :key="item.codigoBeneficiario"
                      :value="familia[index].selecionado"
                      :disabled="
                        (familia[index].selecionado &&
                          titularSelecionado &&
                          !familia[index].titular) ||
                          item.hasMovimentoExclusaoBeneficiario ||
                          isTitularMovimentoAberto
                      "
                      color="primary"
                    ></v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      item.nomeBeneficiario
                    }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary">
                      {{ item.numeroCartao }}
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title
                      v-if="item.hasMovimentoExclusaoBeneficiario"
                      class="secondary--text"
                    >
                      * Já existe um movimento de exclusão para o beneficiário
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider
                  v-if="index + 1 < item.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
            <v-list two-line v-if="documentos">
              <template v-for="item in documentos.content">
                <h5
                  :key="item.id"
                  class="body-2 font-weight-bold primary--text"
                  style="cursor: pointer"
                  @click="download(item.anexo)"
                  v-if="item.anexo"
                >
                  {{ item.descricao }}
                </h5>
              </template>
            </v-list>
            <h4 class="subheading" v-if="titularSelecionado">
              A exclusão do titular de um plano familiar resultará na exclusão
              integral da família. Em caso de mudança de titularidade, procure a
              Operadora.
            </h4>
            <v-checkbox
              v-model="checkbox"
              :color="highContrast ? 'white' : 'primary'"
              class="mb-3"
              label="Li e concordo com as implicações previstas no cancelamento do contrato ou exclusão de beneficiário."
            ></v-checkbox>

            <v-btn
              :outline="!secondStep()"
              :class="[{ 'white--text': !secondStep() }]"
              light
              :color="highContrast ? 'white' : 'primary'"
              class="mx-0"
              :disabled="!secondStep()"
              v-if="dadosBeneficiario.titular"
              @click="criarRascunho()"
              >Próximo</v-btn
            >
            <small class="caption">
              * A exclusão do titular de um plano familiar acarretará na
              exclusão de todos os seus dependentes.
            </small>
          </v-layout>
        </v-layout>
        <v-layout justify-center column v-if="isSegundoPasso" class="mt-1">
          <v-form ref="form" v-model="valid">
            <v-layout row justify-end>
              <p class="my-3 body-2">
                Data de Exclusão:
                {{ rascunho.dataExclusao | formatDate }}
              </p>
            </v-layout>
            <v-layout column>
              <h4 class="subheading font-weight-black primary--text">
                Beneficiários Selecionados
              </h4>
              <template
                v-for="(item,
                index) in rascunho.beneficiarioSelecionadoRequests"
              >
                <v-layout row wrap :key="item.id">
                  <v-flex xs12 md4 lg3 class="px-2">
                    <p class="my-3 body-2">{{ item.nomeBeneficiario }}</p>
                  </v-flex>
                  <v-flex xs12 md4 lg3 class="px-2">
                    <v-select
                      :clearable="true"
                      :items="dmMotivosExclusao"
                      v-model="item.motivoExclusaoId"
                      :rules="motivoExclusaoRules"
                      item-text="descricao"
                      item-value="id"
                      label="Motivo de Exclusão"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4 lg3 class="px-2">
                    <v-select
                      :clearable="true"
                      :items="dmMotivosObito"
                      v-model="item.motivoObitoId"
                      item-text="descricao"
                      item-value="id"
                      label="Motivo Óbito"
                      v-if="
                        item.motivoExclusaoId ===
                          '00000000-0000-0000-0000-000000000003'
                      "
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4 lg3 class="px-2">
                    <v-text-field
                      name="dataObito"
                      label="Data Óbito"
                      type="text"
                      v-model="item.dataObito"
                      :rules="dataObitoRules"
                      required
                      v-mask="'##/##/####'"
                      :masked="true"
                      v-if="
                        item.motivoExclusaoId ===
                          '00000000-0000-0000-0000-000000000003'
                      "
                    ></v-text-field>
                  </v-flex>
                  <v-divider
                    v-if="index + 1 < item.length"
                    :key="index"
                  ></v-divider>
                </v-layout>
              </template>
            </v-layout>
            <v-layout column v-if="isPlanoEmpresarial">
              <h4 class="subheading font-weight-black primary--text mt-2">
                Exclusão de Planos Coletivos
              </h4>
              <v-layout row wrap>
                <v-radio-group v-model="rascunho.solicitouExclusaoRh">
                  <template v-slot:label>
                    <div>Você já solicitou a exclusão ao RH da empresa?:</div>
                  </template>
                  <v-radio label="Sim" color="primary" :value="true"></v-radio>
                  <v-radio label="Não" color="primary" :value="false"></v-radio>
                </v-radio-group>
              </v-layout>
              <v-layout row wrap v-if="rascunho.solicitouExclusaoRh">
                <v-text-field
                  required
                  label="Qual a data que foi solicitada a exclusão?"
                  name="dataSolicitacaoRh"
                  type="text"
                  v-mask="'##/##/####'"
                  v-model="rascunho.dataSolicitacaoRh"
                  :masked="true"
                  :rules="dataSolicitacaoRhRules"
                ></v-text-field>
              </v-layout>
              <v-layout row wrap v-if="rascunho.solicitouExclusaoRh">
                <v-text-field
                  required
                  label="Qual o nome da pessoa que você solicitou a exclusão?"
                  maxlength="40"
                  name="nomePessoaSolicExclusao"
                  type="text"
                  v-model="rascunho.nomePessoaSolicExclusao"
                  :rules="requiredRules"
                ></v-text-field>
              </v-layout>
            </v-layout>
            <v-layout column>
              <h4 class="subheading font-weight-black primary--text mt-2">
                Receber a confirmação de cancelamento por:
              </h4>
              <v-layout row wrap>
                <v-flex xs12 md4 class="px-2">
                  <v-radio-group v-model="rascunho.tipoEnvioComunicado">
                    <v-radio label="E-mail" value="E" color="primary"></v-radio>
                    <v-radio
                      label="Correspondência"
                      value="C"
                      color="primary"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout column v-if="rascunho.tipoEnvioComunicado === 'C'">
              <h4 class="subheading font-weight-black primary--text">
                Endereço
              </h4>
              <v-layout row wrap>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="cep"
                    label="CEP"
                    type="text"
                    v-model="endereco.cep"
                    v-mask="'#####-###'"
                    required
                    data-cy="cepField"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="street"
                    label="Rua"
                    type="text"
                    v-model="endereco.logradouro"
                    :rules="requiredRules"
                    maxlength="100"
                    required
                    data-cy="streetField"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="number"
                    label="Número"
                    type="text"
                    v-model="endereco.numero"
                    v-mask="'#####'"
                    :rules="requiredRules"
                    required
                    data-cy="numberField"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="district"
                    label="Bairro"
                    type="text"
                    v-model="endereco.bairro"
                    maxlength="40"
                    :rules="requiredRules"
                    required
                    data-cy="districtField"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="complement"
                    label="Complemento"
                    type="text"
                    v-model="endereco.complemento"
                    maxlength="30"
                    required
                    data-cy="complementField"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="city"
                    label="Cidade"
                    type="text"
                    v-model="endereco.cidade"
                    maxlength="72"
                    :rules="requiredRules"
                    required
                    data-cy="cityField"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="state"
                    label="Estado"
                    type="text"
                    v-model="endereco.uf"
                    v-mask="'SS'"
                    :rules="requiredRules"
                    required
                    data-cy="stateField"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout column>
              <h4 class="subheading font-weight-black primary--text mt-2">
                Contato
              </h4>
              <v-layout row wrap>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="phone"
                    label="Telefone"
                    type="text"
                    v-model="contato.telefone"
                    v-mask="'(##) ####-####'"
                    required
                    data-cy="phoneField"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="cellPhone"
                    label="Celular"
                    type="text"
                    v-model="contato.celular"
                    v-mask="'(##) #####-####'"
                    required
                    data-cy="cellPhoneField"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  md4
                  class="px-2"
                  v-if="rascunho.tipoEnvioComunicado === 'E'"
                >
                  <v-text-field
                    name="email"
                    label="E-mail"
                    type="text"
                    v-model="contato.email"
                    :rules="[emailRequired, emailValid]"
                    data-cy="emailField"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  md4
                  class="px-2"
                  v-if="rascunho.tipoEnvioComunicado === 'C'"
                >
                  <v-text-field
                    name="email2"
                    label="E-mail"
                    type="text"
                    v-model="contato.email"
                    :rules="[emailValid]"
                    v-if="rascunho.tipoEnvioComunicado !== 'E'"
                    data-cy="email2Field"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout column v-if="isFaturaContraTitular">
              <h4 class="subheading font-weight-black primary--text mt-2">
                Dados Bancários
              </h4>
              <v-layout row wrap>
                <v-flex xs12 md4 class="px-2">
                  <v-select
                    clearable
                    item-text="descricao"
                    item-value="id"
                    label="Tipo Conta"
                    v-model="rascunho.contaBancariaTipoConta"
                    :items="dmTiposContaBancaria"
                    :disabled="isEditDisable"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-select
                    clearable
                    name="banco"
                    label="Banco"
                    v-model="rascunho.banco"
                    v-mask="'##########'"
                    :disabled="isEditDisable"
                    item-text="customLabel"
                    item-value="codigo"
                    :items="codigosBancos"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="contaBancariaAgencia"
                    label="Agência"
                    type="text"
                    v-model="rascunho.contaBancariaAgencia"
                    v-mask="'####'"
                    :disabled="isEditDisable"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="contaBancariaAgenciaDigito"
                    label="Dígito da Agência"
                    type="text"
                    v-model="rascunho.contaBancariaAgenciaDigito"
                    v-mask="'##'"
                    :disabled="isEditDisable"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="rascunho.contaBancariaNumero"
                    label="Número da Conta"
                    type="text"
                    v-model="rascunho.contaBancariaNumero"
                    v-mask="'XXXXXXXXXXXXXXX'"
                    :disabled="isEditDisable"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="rascunho.contaBancariaDigito"
                    label="Dígito da Conta"
                    type="text"
                    v-model="rascunho.contaBancariaDigito"
                    v-mask="'##'"
                    :disabled="isEditDisable"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="rascunho.contaBancariaNome"
                    label="Nome"
                    type="text"
                    v-model="rascunho.contaBancariaNome"
                    maxlength="120"
                    :disabled="isEditDisable"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-2">
                  <v-text-field
                    name="rascunho.contaBancariaCpf"
                    label="CPF"
                    type="text"
                    v-model="rascunho.contaBancariaCpf"
                    v-mask="'###.###.###-##'"
                    :disabled="isEditDisable"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout justify-center align-center row>
              <v-btn
                outline
                :color="highContrast ? 'white' : 'primary'"
                @click="onClickVoltar"
                >Voltar</v-btn
              >
              <v-btn
                light
                :color="highContrast ? 'white' : 'primary'"
                :disabled="
                  !valid ||
                    isTipoComunicadoEmail ||
                    isTipoComunicadoCorrespondencia ||
                    isValidaDadosBancarios
                "
                @click="salvar()"
                >Próximo</v-btn
              >
            </v-layout>
          </v-form>
        </v-layout>
        <v-layout justify-center column v-if="isTerceiroPasso" class="mt-1">
          <v-form ref="form" v-model="valid">
            <v-layout justify-center column>
              <mensagem-anexo
                :parametro-id="parametroMensagemAnexo"
              ></mensagem-anexo>
              <v-data-table
                :headers="headers"
                :items="formularios"
                :pagination.sync="pagination"
                :total-items="formularios.length"
                :loading="isLoading"
                :rows-per-page-items="[5, 10, 25]"
                no-data-text="Não há registros"
                rows-per-page-text="Linhas por página"
                class="elevation-5 mt-4"
                v-if="formularios.length > 0"
              >
                <template v-slot:items="props">
                  <td>{{ props.item.filename || "" }}</td>
                  <td>
                    <v-btn
                      flat
                      small
                      color="green"
                      @click="downloadFormulario(props.item)"
                      >Baixar</v-btn
                    >
                  </td>
                </template>
              </v-data-table>
              <v-layout column class="mt-4">
                <h4 class="subheading font-weight-black primary--text mt-2">
                  Anexos
                </h4>
                <v-layout row wrap>
                  <v-flex xs12 md4 class="px-2">
                    <v-select
                      :clearable="true"
                      :items="dmTiposAnexos"
                      v-model="anexo.tipo"
                      item-text="descricao"
                      item-value="id"
                      label="Tipo Anexo"
                    ></v-select>
                    <label
                      >Extensões permitidas:
                      .zip,.pdf,.csv,.xls,.odt,.doc,.docx,.txt,.png,.jpg,.jpeg.
                    </label>
                  </v-flex>
                  <v-flex xs12 md4 class="px-2">
                    <v-layout row>
                      <v-text-field
                        name="filename"
                        label="Arquivo"
                        type="text"
                        v-model="anexo.arquivo"
                        disabled
                        :rules="anexoRules"
                      ></v-text-field>
                      <v-btn
                        flat
                        icon
                        color="grey darken-2"
                        class="body-2 text-none"
                        @click="$refs.file.click()"
                      >
                        <v-icon>attach_file</v-icon>
                      </v-btn>

                      <input
                        type="file"
                        style="display: none"
                        @change="uploadAnexo"
                        ref="file"
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md4 class="px-2">
                    <v-btn
                      light
                      @click="adicionarAnexo()"
                      :disabled="!anexo.tipo || !anexo.arquivo"
                      :color="highContrast ? 'white' : 'primary'"
                      >Adicionar</v-btn
                    >
                  </v-flex>
                </v-layout>
                <v-list two-line v-if="movimentoAnexos">
                  <template v-for="(item, index) in movimentoAnexos">
                    <v-list-tile :key="item.id" ripple>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ item.anexo.filename }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">
                          {{ item.tipoAnexo.descricao }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-icon @click="removerAnexo(index)">delete</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < anexos.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list>
              </v-layout>
              <v-layout justify-center align-center row>
                <v-btn
                  outline
                  :color="highContrast ? 'white' : 'primary'"
                  @click="onClickVoltar"
                  >Voltar</v-btn
                >
                <v-btn
                  light
                  :color="highContrast ? 'white' : 'primary'"
                  :disabled="!valid || !fileUploadMandatory || isLoading"
                  @click="enviarFormulario()"
                  >Próximo</v-btn
                >
              </v-layout>
            </v-layout>
          </v-form>
        </v-layout>
      </v-card>
      <v-layout row justify-end align-center wrap>
        <small class="caption ma-2"
          >A exclusão do plano será analisada previamente pela Unimed</small
        >
      </v-layout>
    </v-layout>
    <loading-dialog
      :show="isLoading"
      :message="loadingMessage"
    ></loading-dialog>
    <error-dialog
      @close="closeErrorDialog"
      :show="isError"
      :message="errorMessage"
    ></error-dialog>
    <modal-movimento
      @close="modal.MOVIMENTO_ERRO_AUDITORIA.visible = false"
      :show="modal.MOVIMENTO_ERRO_AUDITORIA.visible"
      :message="modal.MOVIMENTO_ERRO_AUDITORIA.content"
      :titulo="modal.MOVIMENTO_ERRO_AUDITORIA.titulo"
    ></modal-movimento>
    <modal-movimento-aberto
      @close="modal.MOVIMENTO_ABERTO.visible = false"
      :show="modal.MOVIMENTO_ABERTO.visible"
      :message="modal.MOVIMENTO_ABERTO.content"
    ></modal-movimento-aberto>
    <modal-movimento-duplicado
      @close="modal.MOVIMENTO_DUPLICADO.visible = false"
      @overwrite="sobrescreverMovimento"
      :show="modal.MOVIMENTO_DUPLICADO.visible"
      :message="modal.MOVIMENTO_DUPLICADO.content"
    ></modal-movimento-duplicado>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { mask } from "vue-the-mask";
import moment from "moment";

import { WEB_SERVICE } from "@/constants";
import router from "@/router";

import BeneficiaryData from "@/components/BeneficiaryData";
import ErrorDialog from "@/components/ErrorDialog";
import LoadingDialog from "@/components/LoadingDialog";
import MensagemAnexo from "@/components/MensagemAnexo";
import ModalMovimento from "@/components/ModalMovimento";
import ModalMovimentoAberto from "@/components/ModalMovimentoAberto";
import ModalMovimentoDuplicado from "@/components/ModalMovimentoDuplicado";

import {
  getAnexo,
  getDocumentos,
  getTiposContaBancaria,
  getParametro,
  getMovimentoFormularios,
  downloadFormulario
} from "@/services/beneficiario";
import {
  createExclusaoSolicBeneficiarioRascunho,
  enviarMovimentoParaAuditoria,
  exclusaoPrepararEnvio,
  getCodigosBancos,
  getFamiliaBeneficiarioParaExclusao,
  getMovimentosDuplicados,
  listarTiposAnexo,
  getMotivosExclusao,
  getMotivosObito,
  listarMovimentoAnexos,
  removerAnexo,
  saveExclusaoSolicBeneficiario,
  cadastrarAnexo,
  cancelarMovimento,
  cancelarMovimentos
} from "@/services/movimentos";
import { formatDateRestore } from "@/utils/date";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

const TERMO_CIENCIA_EXCLUSAO = 6;

const TIPO_ANEXO_COMPROVANTE_EXCLUSAO = 20;

const PRAZO_SOLICITACAO_PLANO_EMPRESA = 30;

export default {
  name: "PlanDelete",
  directives: { mask },
  components: {
    BeneficiaryData,
    ErrorDialog,
    LoadingDialog,
    MensagemAnexo,
    ModalMovimento,
    ModalMovimentoAberto,
    ModalMovimentoDuplicado
  },
  data() {
    return {
      codigosBancos: null,
      motivoExclusaoRules: [v => !!v || "A Motivo da Exclusão é obrigatório"],
      requiredRules: [v => !!v || "O campo é obrigatório"],
      dataObitoRules: [
        v => !!v || "A Data de Óbito é obrigatória",
        v => (v && v.length === 10) || "A Data de Óbito deve ser válida"
      ],
      dataSolicitacaoRhRules: [
        v => !!v || "A Data de Solicitação é obrigatória",
        v => (v && v.length === 10) || "A Data de Solicitação deve ser válida"
      ],
      emailRequired: v => !!v || "O E-mail é obrigatório",
      emailValid: v => !v || /.+@.+/.test(v) || "O E-mail deve ser válido",
      anexoRequired: v => !!v || "O anexo é obrigatório”",
      anexoValid: v => v !== null || "O anexo não é válido",
      checkbox: false,
      step: 1,
      totalStep: 3,
      headers: [
        { text: "Título", value: "id" },
        { text: "Anexo", value: "arquivoId" }
      ],
      bloquearRascunho: false,
      dialog: false,
      motivo: null,
      valid: false,
      readonlyBanco: false,
      movimentoId: null,
      dmTiposAnexos: null,
      dmMotivosExclusao: null,
      dmMotivosObito: null,
      dmTiposContaBancaria: null,
      movimentoAnexos: null,
      isEditDisable: false,
      file: null,
      isError: false,
      errorMessage: null,
      parametroMensagemAnexo: 3,
      loadingMessage: "Aguarde, carregando!",
      modal: {
        MOVIMENTO_ABERTO: { visible: false, content: null },
        MOVIMENTO_ERRO_AUDITORIA: {
          content:
            "Ocorreu um erro ao enviar o movimento para auditoria." +
            "<br />Tente novamente mais tarde ou entre em contato com a sua operadora.",
          titulo: "Erro ao enviar para auditoria",
          visible: false
        },
        MOVIMENTO_DUPLICADO: {
          visible: false,
          content: null,
          movimentoId: null
        }
      },
      endereco: {
        tipoEndereco: {
          id: "00000000-0000-0000-0000-000000000001",
          descricao: "Minha residência"
        },
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
        caixaPostal: "",
        pontoDeReferencia: ""
      },
      contato: {
        celular: "",
        telefone: "",
        email: ""
      },
      anexo: {
        tipo: null,
        arquivo: null
      },
      formularios: [],
      rascunho: {
        tipoEnvioComunicado: null,
        banco: null,
        tipoContaBancaria: null,
        contaBancariaAgencia: null,
        contaBancariaAgenciaDig: null,
        contaBancariaNumero: null,
        contaBancariaDigito: null,
        contaBancariaCpf: null,
        contaBancariaNome: null,
        beneficiarioSelecionadoRequests: [],
        solicitouExclusaoRh: null,
        dataSolicitacaoRh: null,
        nomePessoaSolicExclusao: null
      },
      anexos: [],
      familia: [],
      titularSelecionado: false,
      documentos: null,
      beneficiarioExcluidoEmpresa: {
        message: ""
      },
      isAnexoRequired: false
    };
  },
  computed: {
    ...beneficiarioStore.mapState(["dadosBeneficiario"]),
    ...portalStore.mapState(["highContrast", "loading", "usuario"]),
    contratoId() {
      return this.dadosBeneficiario.contratoId;
    },
    fileUploadMandatory() {
      return this.isAnexoRequired && this.isPlanoEmpresarial
        ? this.movimentoAnexos.length >= 1
        : true;
    },
    planoRegistroAns() {
      return this.dadosBeneficiario.planoRegistroAns;
    },
    isLoading() {
      return this.loading;
    },
    isPrimeiroPasso() {
      return this.step === 1;
    },
    isSegundoPasso() {
      return this.step === 2;
    },
    isTerceiroPasso() {
      return this.step === 3;
    },
    isTitularMovimentoAberto() {
      if (this.familia.length < 1) {
        return false;
      }

      const titular = this.familia.find(({ titular }) => titular);

      if (!titular) {
        return false;
      }

      return titular.hasMovimentoExclusaoBeneficiario;
    },
    anexoRules() {
      return this.isAnexoRequired && this.planoEmpresarial
        ? [this.anexoRequired, this.anexoValid]
        : [];
    },
    isTipoComunicadoEmail() {
      if (this.rascunho.tipoEnvioComunicado === "E" && !this.contato.email) {
        return true;
      } else {
        return false;
      }
    },
    isTipoComunicadoCorrespondencia() {
      if (
        this.rascunho.tipoEnvioComunicado === "C" &&
        (!this.endereco.logradouro ||
          !this.endereco.numero ||
          !this.endereco.bairro ||
          !this.endereco.cidade ||
          !this.endereco.uf)
      ) {
        return true;
      } else {
        return false;
      }
    },
    isFaturaContraTitular() {
      return this.dadosBeneficiario?.faturaContra === "T";
    },
    isValidaDadosBancarios() {
      if (
        this.rascunho.contaBancariaCpf &&
        this.rascunho.contaBancariaNome &&
        this.rascunho.banco &&
        this.rascunho.contaBancariaTipoConta &&
        this.rascunho.contaBancariaAgencia &&
        this.rascunho.contaBancariaNumero
      ) {
        return false;
      } else if (
        this.rascunho.contaBancariaCpf ||
        this.rascunho.contaBancariaNome ||
        this.rascunho.banco ||
        this.rascunho.contaBancariaTipoConta ||
        this.rascunho.contaBancariaAgencia ||
        this.rascunho.contaBancariaNumero ||
        this.rascunho.contaBancariaDigito ||
        this.rascunho.contaBancariaAgenciaDigito
      ) {
        return true;
      } else {
        return false;
      }
    },
    isPlanoEmpresarial() {
      return this.dadosBeneficiario?.planoEmpresarial;
    },
    hasComprovanteExclusao() {
      if (this.isPlanoEmpresarial) {
        const comprovanteExclusao = this.movimentoAnexos?.find(
          movimentoAnexo =>
            movimentoAnexo?.tipoAnexo?.id === TIPO_ANEXO_COMPROVANTE_EXCLUSAO
        );

        return comprovanteExclusao;
      }

      return true;
    }
  },
  watch: {
    familia: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          const oldValue = this.titularSelecionado;
          this.titularSelecionado = newValue.find(
            x => x.titular && x.selecionado
          )
            ? true
            : false;
          if (this.titularSelecionado) {
            for (let index = 0; index < this.familia.length; index++) {
              this.familia[index].selecionado = true;
            }
          } else if (oldValue) {
            for (let index = 0; index < this.familia.length; index++) {
              this.familia[index].selecionado = false;
            }
          }
        }
      }
    },
    dmTiposAnexos: {
      handler() {
        if (
          this.isAnexoRequired &&
          this.isPlanoEmpresarial &&
          this.dmTiposAnexos &&
          !this.anexo?.tipo
        ) {
          const compravanteExclusaoRh = this.dmTiposAnexos.find(
            ({ id }) => id === TIPO_ANEXO_COMPROVANTE_EXCLUSAO
          );
          this.anexo.tipo = compravanteExclusaoRh?.id || null;
        }
      }
    }
  },
  async mounted() {
    this.setShowLoading(true);

    await this.getCodigosBancos();
    this.codigosBancos = this.codigosBancos.map(banco => {
      return { ...banco, customLabel: `${banco.codigo} - ${banco.nome}` };
    });
    await this.getParametroBeneficiarioExcluidoEmpresaMessage();
    await this.getParametroAnexoRequired();

    const beneficiarioCartao = this.dadosBeneficiario.id;

    getFamiliaBeneficiarioParaExclusao(beneficiarioCartao).then(response => {
      const errorMessage = response.data?.message.split("|");

      if (errorMessage) {
        if (WEB_SERVICE.includes(errorMessage[0])) {
          this.setErrorToast(response.data.message);
        } else {
          this.setToast(response.data.message);
        }
        this.setShowLoading(false);
      } else {
        if (response.length > 0) {
          this.familia = response.map(beneficiario => ({
            codigoBeneficiario: beneficiario.codigoBeneficiario,
            numeroCartao: beneficiario.numeroCartao,
            nomeBeneficiario: beneficiario.nomeBeneficiario,
            selecionado: false,
            titular: beneficiario.titular,
            hasMovimentoExclusaoBeneficiario:
              beneficiario.hasMovimentoExclusaoRN412
          }));

          this.setShowLoading(false);
        }
      }
    });
  },
  created() {
    this.getDocumentos();
  },
  methods: {
    ...portalStore.mapMutations([
      "setErrorToast",
      "setShowLoading",
      "setToast"
    ]),
    download(anexo) {
      getAnexo(anexo.identificador).then(response => {
        if (response) {
          let blob = new Blob([response], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = anexo.filename;
          link.click();
        }
      });
    },
    sobrescreverMovimento() {
      const movimentosId = this.modal.MOVIMENTO_DUPLICADO.movimentosId;

      cancelarMovimentos(movimentosId).finally(() => {
        this.modal.MOVIMENTO_DUPLICADO.visible = false;
        this.bloquearRascunho = false;

        this.criarRascunho();
      });
    },
    secondStep() {
      return (
        this.checkbox &&
        this.familia.find(beneficiario => beneficiario.selecionado)
      );
    },
    uploadAnexo(e) {
      this.file = e.target.files[0];
      this.anexo.arquivo = this.file.name;
    },
    adicionarAnexo() {
      this.setShowLoading(true);

      let fd = new FormData();
      fd.append("arquivo", this.file);
      fd.append("movimento", this.rascunho.id);
      fd.append("tipoAnexo", this.anexo.tipo);
      cadastrarAnexo(this.anexo.tipo, this.rascunho.id, fd)
        .then(() => {
          this.listarMovimentoAnexos();
        })
        .finally(() => this.setShowLoading(false));
      this.anexo.tipo = null;
    },
    removerAnexo(index) {
      const arquivoId = this.movimentoAnexos[index].anexo.arquivoId;
      removerAnexo(arquivoId).then(() => {
        this.movimentoAnexos.splice(index, 1);
      });
    },
    async criarRascunho() {
      this.setShowLoading(true);
      await getMovimentosDuplicados({
        codigoBeneficiario: this.dadosBeneficiario.id,
        tipoMovimentoId: 6
      })
        .then(response => {
          const errorMessage = response.data?.message;

          if (errorMessage) {
            this.bloquearRascunho = true;

            const resultado = errorMessage.split("|");

            if (WEB_SERVICE.includes(resultado[0])) {
              this.setErrorToast(errorMessage);
            } else {
              this.modal.MOVIMENTO_ABERTO.visible = true;
              this.modal.MOVIMENTO_ABERTO.content = errorMessage.replace(
                "\n",
                "<br>"
              );
            }
          } else {
            if (response.length) {
              const movimento = response.filter(
                movimento =>
                  movimento?.nomeBeneficiario &&
                  movimento?.tipoMovimento?.descricao
              )[0];
              const movimentosId = response.map(movimento => movimento.id);

              this.bloquearRascunho = true;
              this.loading = false;
              this.modal.MOVIMENTO_DUPLICADO.visible = true;
              this.modal.MOVIMENTO_DUPLICADO.content = `Foi encontrado um movimento de ${
                movimento?.tipoMovimento?.descricao
              } criado para ${movimento?.nomeBeneficiario}!`;
              this.modal.MOVIMENTO_DUPLICADO.movimentosId = movimentosId;
            }
          }
        })
        .finally(() => this.setShowLoading(false));

      if (!this.bloquearRascunho) {
        const beneficiariosSelecionados = this.familia
          .filter(beneficiario => beneficiario.selecionado)
          .map(beneficiario => {
            return {
              beneficiario: beneficiario.codigoBeneficiario,
              numeroCartao: beneficiario.numeroCartao,
              nomeBeneficiario: beneficiario.nomeBeneficiario,
              titular:
                this.dadosBeneficiario.id === beneficiario.codigoBeneficiario
            };
          });
        const exclusaoBeneficiario = {
          beneficiarioCartao: this.dadosBeneficiario.id,
          beneficiarioSelecionadoRequests: beneficiariosSelecionados,
          usuarioId: this.usuario.id
        };

        this.setShowLoading(true);
        createExclusaoSolicBeneficiarioRascunho(exclusaoBeneficiario)
          .then(response => {
            this.step = 2;
            response.dataExclusao = new Date().toISOString().substr(0, 10);
            response.beneficiarioSelecionadoRequests = response.exclusaoBeneficiarioSelecionados.map(
              x => {
                x.motivoExclusaoId = x.motivoExclusao
                  ? x.motivoExclusao.id
                  : null;
                x.motivoObitoId = x.motivoObito ? x.motivoObito.id : null;
                return x;
              }
            );
            response.tipoEnvioComunicado = response.tipoEnvioComunicado
              ? response.tipoEnvioComunicado
              : "E";

            this.rascunho = response;

            this.motivosExclusao();
            this.motivosObito();
            this.tiposContaBancaria();
            this.tiposAnexos();
            this.listarMovimentoAnexos();
          })
          .catch(({ response }) => {
            let errorMessage = response.data?.message;
            errorMessage = errorMessage.split(": ")[1] || errorMessage;

            const resultado = errorMessage.split("|");

            if (WEB_SERVICE.includes(resultado[0])) {
              this.setErrorToast(errorMessage);
            } else {
              this.modal.MOVIMENTO_ABERTO.visible = true;
              this.modal.MOVIMENTO_ABERTO.content = errorMessage.replace(
                "\n",
                "<br>"
              );
            }
          })
          .finally(() => this.setShowLoading(false));
      }
    },
    async salvar() {
      if (this.isPlanoEmpresarial && !this.rascunho.solicitouExclusaoRh) {
        this.isError = true;
        this.errorMessage =
          "É necessário solicitar a exclusão ao RH da empresa!";
      } else if (this.isPlanoEmpresarial && !this.validaDataSolicitacaoRh()) {
        this.isError = true;
        this.errorMessage = `Você deve esperar o prazo de ${PRAZO_SOLICITACAO_PLANO_EMPRESA} dias após a solicitação na empresa!`;
      } else {
        this.rascunho.codigoEmpresa = this.dadosBeneficiario.empresaId;
        this.rascunho.movimentoContatos = [];
        if (this.contato.email) {
          this.rascunho.movimentoContatos.push({
            tipoContato: {
              id: "00000000-0000-0000-0000-000000000003"
            },
            contato: this.contato.email
          });
        }

        if (this.contato.telefone) {
          this.rascunho.movimentoContatos.push({
            tipoContato: {
              id: "00000000-0000-0000-0000-000000000002"
            },
            contato: this.contato.telefone.replace(/\D/g, "")
          });
        }
        if (this.contato.celular) {
          this.rascunho.movimentoContatos.push({
            tipoContato: {
              id: "00000000-0000-0000-0000-000000000001"
            },
            contato: this.contato.celular.replace(/\D/g, "")
          });
        }
        if (this.rascunho.tipoEnvioComunicado === "C") {
          this.rascunho.movimentoEndereco = {
            ...this.endereco,
            cep: this.endereco.cep.replace(/\D/g, "")
          };
        }

        if (this.rascunho.contaBancariaCpf) {
          this.rascunho.contaBancariaCpf = this.rascunho.contaBancariaCpf.replace(
            /\D/g,
            ""
          );
        }

        this.rascunho.beneficiarioSelecionadoRequests = this.rascunho.beneficiarioSelecionadoRequests.map(
          beneficiario => {
            let dataObitoFormatada = null;

            if (beneficiario.dataObito) {
              dataObitoFormatada = formatDateRestore(beneficiario.dataObito);
            }

            return {
              ...beneficiario,
              dataObito: dataObitoFormatada
            };
          }
        );

        if (this.rascunho?.dataSolicitacaoRh) {
          this.rascunho.dataSolicitacaoRh = formatDateRestore(
            this.rascunho.dataSolicitacaoRh
          );
        }

        const rascunho = JSON.parse(JSON.stringify(this.rascunho));

        this.setShowLoading(true);

        const response = await saveExclusaoSolicBeneficiario(
          this.rascunho.id,
          rascunho
        );

        if (response?.response) {
          this.trataSaveExclusaoError(response?.response);
          return;
        }

        const movimentoId = [this.rascunho.id];

        const enviarParaAuditoria = await this.enviarExclusaoPrepararEnvio(
          movimentoId
        );

        if (enviarParaAuditoria) {
          this.formularios = (await getMovimentoFormularios(movimentoId)) || [];

          this.step = 3;
        }

        this.setShowLoading(false);
      }
    },
    async enviarFormulario() {
      if (!this.hasComprovanteExclusao) {
        this.isError = true;
        this.errorMessage =
          "É obrigatório anexar o Comprovante de exclusão do RH!";
      } else {
        this.setShowLoading(true);
        const movimentoId = [this.rascunho.id];
        this.enviarMovimentoParaAuditoria(movimentoId);
      }
    },
    trataSaveExclusaoError(response) {
      const errorMessage = response.data?.message;

      if (errorMessage) {
        const resultado = errorMessage.split("|");
        if (WEB_SERVICE.includes(resultado[0])) {
          this.setErrorToast(errorMessage);
        } else {
          this.modal.MOVIMENTO_ABERTO.content = errorMessage.replace(
            "\n",
            "<br>"
          );
          this.modal.MOVIMENTO_ABERTO.visible = true;
        }

        this.setShowLoading(false);
      }
    },
    enviarExclusaoPrepararEnvio(movimentoId) {
      return new Promise(resolve => {
        exclusaoPrepararEnvio(movimentoId)
          .then(() => resolve(true))
          .catch(({ response }) => {
            const resultado = response.data.message.split("|");

            if (WEB_SERVICE.includes(resultado[0])) {
              this.setErrorToast(response.data?.message);
            } else {
              const error = response.data
                ? response.data.message
                : response.message;

              this.isError = true;
              this.errorMessage = error.replace(/(?:\r\n|\r|\n)/g, "<br>");
            }

            this.setShowLoading(false);
            resolve(false);
          });
      });
    },
    enviarMovimentoParaAuditoria(movimentoId) {
      enviarMovimentoParaAuditoria(movimentoId)
        .then(() => {
          this.step = 1;
          this.checkbox = false;
          this.setToast(
            "Sua exclusão foi confirmada, ela será analisada pela Unimed."
          );
          router.push({ name: "movement" });
        })
        .catch(() => {
          cancelarMovimento(movimentoId);
          this.modal.MOVIMENTO_ERRO_AUDITORIA.visible = true;
        })
        .finally(() => {
          this.setShowLoading(false);
        });
    },
    onClickVoltar() {
      this.step = this.step === 1 ? 1 : this.step - 1;
    },
    async downloadFormulario(formulario) {
      const { data } = await downloadFormulario(formulario.arquivoId);
      const blob = new global.Blob([data], { type: "text/pdf" });
      const src = global.window.URL.createObjectURL(blob);
      const element = global.document.createElement("a");

      element.href = src;
      element.download = `${formulario.filename}.${formulario.mediaType}`;
      element.click();
    },
    closeErrorDialog() {
      this.isError = false;
      this.errorMessage = null;
    },
    exibeErro(response) {
      const resultado = response.data.message.split("|");

      this.setShowLoading(false);
      if (WEB_SERVICE.includes(resultado[0])) {
        this.setErrorToast(response?.data?.message);
      } else {
        this.setToast(response.data.message);
      }
    },
    async getCodigosBancos() {
      this.codigosBancos = await getCodigosBancos().catch(({ response }) => {
        this.exibeErro(response);
      });
    },
    async getParametroBeneficiarioExcluidoEmpresaMessage() {
      const parametroId = 13;

      this.beneficiarioExcluidoEmpresa.message = await getParametro(
        parametroId
      );
    },
    async getParametroAnexoRequired() {
      const parametroId = 14;

      this.isAnexoRequired = (await getParametro(parametroId)) === "true";
    },
    async getDocumentos() {
      const payload = {
        contratoId: this.contratoId,
        codigoPlano: this.planoRegistroAns.trim(),
        tagId: TERMO_CIENCIA_EXCLUSAO
      };

      await getDocumentos(payload).then(({ data, errors }) => {
        this.documentos = data;

        if (errors && errors.length) {
          const errorMessage = errors[0].message.split(": ")[1];

          this.setErrorToast(errorMessage);
        }
      });
    },
    async motivosExclusao() {
      const dependente = !this.familia
        .filter(
          beneficiario => beneficiario.selecionado && beneficiario.titular
        )
        .map(beneficiario => beneficiario.titular)[0];

      await getMotivosExclusao(dependente).then(response => {
        this.dmMotivosExclusao = response;
      });
    },
    async tiposAnexos() {
      await listarTiposAnexo().then(response => {
        this.dmTiposAnexos = response;
      });
    },
    async motivosObito() {
      await getMotivosObito().then(({ data, errors }) => {
        if (errors && errors.length) {
          const errorMessage = errors[0].message.split(": ")[1];

          this.setErrorToast(errorMessage);
        } else {
          this.dmMotivosObito = data.motivosObito;
        }
      });
    },
    async listarMovimentoAnexos() {
      if (this.rascunho.id) {
        await listarMovimentoAnexos(this.rascunho.id).then(response => {
          this.movimentoAnexos = response;
        });
      }
    },
    async tiposContaBancaria() {
      await getTiposContaBancaria().then(response => {
        this.dmTiposContaBancaria = response;
      });
    },
    validaDataSolicitacaoRh() {
      if (this.rascunho?.dataSolicitacaoRh) {
        const hoje = moment().startOf("day");
        const dataInformada = moment(
          this.rascunho.dataSolicitacaoRh,
          "DD/MM/YYYY"
        ).startOf("day");
        const diasDiferenca = hoje.diff(dataInformada, "day");

        return diasDiferenca > PRAZO_SOLICITACAO_PLANO_EMPRESA;
      }

      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/loading.scss";

html {
  overflow: hidden;
}

.subheading {
  font-weight: bold;
  color: red;
}
</style>
